import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { fmtDate } from "../lib/format";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";

export default function MeasurePrint() {
  const { id } = useParams();
  const { user } = useAuth();
  const [m, setM] = useState(null);
  useEffect(() => { api.get(`/measures/${id}`).then((r) => setM(r.data)); }, [id]);
  if (!m) return <div className="p-8 text-sm">Loading…</div>;
  const v = m.current_version;
  return (
    <div className="mx-auto max-w-3xl bg-white p-10 font-serif text-[15px] leading-relaxed text-black" data-testid="print-view">
      <div className="no-print mb-6 flex justify-end"><Button onClick={() => window.print()} data-testid="print-now-button">Print / Save as PDF</Button></div>
      <header className="mb-8 text-center">
        <div className="text-sm uppercase tracking-widest">Republic of the Philippines</div>
        <div className="font-semibold uppercase">{user.lgu?.name}</div>
        <div className="text-sm uppercase">{user.lgu?.legislative_body_name}</div>
      </header>
      {!m.is_locked && <div className="mb-4 border border-black p-2 text-center text-xs font-semibold uppercase">Draft — not an official copy</div>}
      <div className="mb-2 text-center font-semibold">{m.official_number || `Tracking Ref. ${m.tracking_ref}`}</div>
      <h1 className="mb-6 text-center text-base font-bold uppercase">{v?.title || m.proposed_title}</h1>
      <div className="mb-4 text-sm">Sponsor: {m.summary.sponsor || "—"} · Filed: {fmtDate(m.filing_date)}</div>
      <p className="mb-4 whitespace-pre-line">{v?.whereas_clauses}</p>
      <p className="mb-4 whitespace-pre-line font-semibold">{v?.enacting_clause}</p>
      <p className="whitespace-pre-line">{v?.body}</p>
      <footer className="mt-10 border-t pt-2 font-mono text-[10px] text-gray-500">Version {v?.version_no} · SHA-256 {v?.content_hash} · Generated by OTMS</footer>
    </div>
  );
}
